module.exports = __webpack_public_path__ + "@/assets/img/notfound-background.650f8d39.svg";